import { createAction } from '@reduxjs/toolkit';

const clearMyProfile = createAction('profile/clearMyProfile');

export default clearMyProfile;
